<!-- Button to toggle sidenav -->
<!-- <button data-testid="auto-app-insights-joblist-button-1" (click)="toggleSidenav()">☰ Menu</button> -->

<!-- Overlay (optional) -->
<div class="overlay" *ngIf="isOpen" (click)="closeSidenav()"></div>

<!-- Sidenav -->
<div class="insightJoblistsidenav" [class.open]="isOpen">
  <div class="d-flex new-card justify-content-between align-items-center sticky-card slider-header-card">
    <span>
      <span class="font-weight-600">Active Jobs</span>
      <span class="font-weight-600" *ngIf="sliderJoblist.length >0"> ({{totalEntries}})</span>
    </span>
    <button data-testid="auto-app-insights-joblist-button-2" class="close-btn" (click)="closeSidenav()">✖</button>
  </div>
  <div class="h-100 bg-white d-flex align-items-center justify-content-center" *ngIf="sliderJoblist.length==0">
    <div  class="spinner-border text-webbtree-green "
                            role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
  </div>
<div class="h97" #scrollContainer *ngIf="sliderJoblist.length >0">
  <div class="new-card" *ngFor="let job of sliderJoblist">
    <p class="f-14 font-weight-500 mb-1">{{job.job_title | titlecase}}</p>
    <p class="f-12 font-weight-400 mb-1">{{job.company_name |titlecase}}</p>
    <div class="d-flex justify-content-start flex-wrap">
      <span>
        <span>
          <span class="mr-1" *ngIf="job.location_name">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M6.99997 1.16666C4.42747 1.16666 2.33331 3.26082 2.33331 5.83332C2.31581 9.58999 6.48664 12.6 6.66164 12.7283C6.76081 12.7983 6.88331 12.8392 6.99997 12.8392C7.11664 12.8392 7.23914 12.8042 7.33831 12.7283C7.51331 12.6 11.6841 9.59582 11.6666 5.83332C11.6666 3.26082 9.57247 1.16666 6.99997 1.16666ZM6.99997 8.16666C5.71081 8.16666 4.66664 7.12249 4.66664 5.83332C4.66664 4.54416 5.71081 3.49999 6.99997 3.49999C8.28914 3.49999 9.33331 4.54416 9.33331 5.83332C9.33331 7.12249 8.28914 8.16666 6.99997 8.16666Z" fill="#969696"/>
            </svg>
          </span>
          <span class="text-9696 f-12" *ngIf="job.locations.length === 1">{{job.location_name | titlecase}}</span>
          <span class="text-9696 f-12 pointer" *ngIf="job.locations.length > 1"><span [matTooltip]="getLocationsTooltip(job?.locations) | titlecase" [matTooltipClass]="{ 'red-tooltip text-black': true }">Multiple Locations</span></span>
        </span>
        <span class="mx-1" *ngIf=" job.location_name">
          <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
            <circle cx="1.82583" cy="1.82583" r="1.82583" fill="#D9D9D9"/>
          </svg>
        </span>
      </span>

      <span>
        <span>
          <span class="mr-1" *ngIf="job.title_level">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M2.625 12.25C2.625 12.25 1.75 12.25 1.75 11.375C1.75 10.5 2.625 7.875 7 7.875C11.375 7.875 12.25 10.5 12.25 11.375C12.25 12.25 11.375 12.25 11.375 12.25H2.625ZM7 7C7.69619 7 8.36387 6.72344 8.85616 6.23116C9.34844 5.73887 9.625 5.07119 9.625 4.375C9.625 3.67881 9.34844 3.01113 8.85616 2.51884C8.36387 2.02656 7.69619 1.75 7 1.75C6.30381 1.75 5.63613 2.02656 5.14384 2.51884C4.65156 3.01113 4.375 3.67881 4.375 4.375C4.375 5.07119 4.65156 5.73887 5.14384 6.23116C5.63613 6.72344 6.30381 7 7 7Z" fill="#969696"/>
            </svg>
          </span>
          <span class="text-9696 f-12">{{job.title_level | titlecase}}</span>
        </span>
        <span class="mx-1" *ngIf=" job.title_level">
          <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
            <circle cx="1.82583" cy="1.82583" r="1.82583" fill="#D9D9D9"/>
          </svg>
        </span>
      </span>

      <span>
        <span>
          <span class="mr-1" *ngIf="job.work_mode">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <g clip-path="url(#clip0_567_1738)">
                <path d="M13.4237 4.36432V3.6384C13.4237 3.34629 13.3077 3.06614 13.1012 2.85959C12.8946 2.65304 12.6145 2.537 12.3223 2.537H10.9756L10.8405 1.71596C10.8047 1.49802 10.6922 1.30006 10.5232 1.15778C10.3543 1.01549 10.1401 0.938242 9.91929 0.93997H8.10199C7.882 0.939436 7.669 1.01722 7.50114 1.15941C7.33327 1.30159 7.22149 1.49888 7.18582 1.71596L7.05065 2.537H5.70394C5.41183 2.537 5.13168 2.65304 4.92513 2.85959C4.71858 3.06614 4.60254 3.34629 4.60254 3.6384V4.36432H13.4237ZM7.91675 1.86114C7.9239 1.82005 7.94547 1.78285 7.97759 1.75623C8.00971 1.72962 8.05027 1.71534 8.09197 1.71596H9.91929C9.961 1.71534 10.0016 1.72962 10.0337 1.75623C10.0658 1.78285 10.0874 1.82005 10.0945 1.86114L10.2097 2.56203H7.80661L7.91675 1.86114ZM9.38862 5.11527V5.8462C9.38862 5.94579 9.34906 6.04129 9.27865 6.11171C9.20823 6.18212 9.11273 6.22168 9.01314 6.22168C8.91356 6.22168 8.81806 6.18212 8.74764 6.11171C8.67723 6.04129 8.63767 5.94579 8.63767 5.8462V5.11527H4.60254V7.4983C4.60254 7.64294 4.63103 7.78616 4.68638 7.91979C4.74173 8.05342 4.82286 8.17484 4.92513 8.27711C5.02741 8.37938 5.14882 8.46051 5.28245 8.51586C5.41608 8.57121 5.5593 8.5997 5.70394 8.5997H12.3223C12.6145 8.5997 12.8946 8.48366 13.1012 8.27711C13.3077 8.07056 13.4237 7.79041 13.4237 7.4983V5.11527H9.38862ZM10.0144 10.397L8.51251 10.8976C8.49301 10.8965 8.47362 10.9012 8.45671 10.9109C8.43981 10.9207 8.42614 10.9352 8.41739 10.9527C8.34822 11.1028 8.23733 11.2298 8.09796 11.3185C7.95859 11.4073 7.79663 11.4541 7.63139 11.4533H5.91421C5.85711 11.4533 5.80236 11.4306 5.76198 11.3903C5.72161 11.3499 5.69893 11.2951 5.69893 11.2381C5.69893 11.181 5.72161 11.1262 5.76198 11.0858C5.80236 11.0455 5.85711 11.0228 5.91421 11.0228H7.63639C7.75058 11.0228 7.86009 10.9774 7.94084 10.8967C8.02158 10.8159 8.06694 10.7064 8.06694 10.5922C8.06694 10.478 8.02158 10.3685 7.94084 10.2878C7.86009 10.207 7.75058 10.1617 7.63639 10.1617H6.13449C5.63801 9.78172 5.03688 9.56329 4.4123 9.53589H3.53618C3.26833 9.5372 3.00442 9.6006 2.7652 9.72113L1.46856 10.3669C1.45256 10.3754 1.43878 10.3875 1.42834 10.4023C1.41791 10.4171 1.4111 10.4341 1.40848 10.4521V12.77C1.40799 12.7894 1.41288 12.8085 1.4226 12.8253C1.43231 12.8421 1.44649 12.8559 1.46355 12.8651C1.48029 12.8748 1.49929 12.8799 1.51862 12.8799C1.53795 12.8799 1.55695 12.8748 1.57369 12.8651L2.95545 12.004C3.00975 11.969 3.07109 11.9464 3.13511 11.9378C3.19913 11.9291 3.26427 11.9346 3.32592 11.954C7.61136 13.4008 6.17954 13.4058 11.0107 10.9527C11.0441 10.9363 11.0728 10.9118 11.0942 10.8813C11.1156 10.8509 11.1289 10.8155 11.1329 10.7785C11.1369 10.7415 11.1314 10.7041 11.1171 10.6698C11.1027 10.6355 11.0799 10.6053 11.0507 10.5822C10.9079 10.466 10.7378 10.3881 10.5565 10.3557C10.3752 10.3233 10.1887 10.3375 10.0144 10.397Z" fill="#969696"/>
              </g>
              <defs>
                <clipPath id="clip0_567_1738">
                  <rect width="14" height="14" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </span>
          <span class="text-9696 f-12">
            {{job.work_mode | titlecase}}
          </span>
        </span>
        <span class="mx-1" *ngIf="job.salary_min || job.salary_max">
          <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
            <circle cx="1.82583" cy="1.82583" r="1.82583" fill="#D9D9D9"/>
          </svg>
        </span>
      </span>
      <span>
        <span class="mr-1" *ngIf="job.salary_min || job.salary_max">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <g clip-path="url(#clip0_567_1743)">
              <path d="M12.25 6.41842H12.1474L11.084 3.30751L1.95654 6.41842L1.75004 6.41667M1.45837 6.41901H1.75004L8.25187 1.22501L9.89512 3.52917" stroke="#969696" stroke-width="1.16667" stroke-linecap="square"/>
              <path d="M8.45841 9.33336C8.45841 9.72014 8.30477 10.0911 8.03128 10.3646C7.75779 10.6381 7.38686 10.7917 7.00008 10.7917C6.61331 10.7917 6.24237 10.6381 5.96888 10.3646C5.69539 10.0911 5.54175 9.72014 5.54175 9.33336C5.54175 8.94659 5.69539 8.57566 5.96888 8.30217C6.24237 8.02868 6.61331 7.87503 7.00008 7.87503C7.38686 7.87503 7.75779 8.02868 8.03128 8.30217C8.30477 8.57566 8.45841 8.94659 8.45841 9.33336Z" stroke="#969696" stroke-width="1.16667" stroke-linecap="square"/>
              <path d="M12.5417 6.41669V12.25H1.45837V6.41669H12.5417Z" stroke="#969696" stroke-width="1.16667" stroke-linecap="square"/>
              <path d="M1.45837 6.41669H2.62504C2.62504 6.72611 2.50212 7.02285 2.28333 7.24164C2.06454 7.46044 1.76779 7.58335 1.45837 7.58335V6.41669ZM12.5417 6.41669H11.375C11.375 6.72611 11.498 7.02285 11.7167 7.24164C11.9355 7.46044 12.2323 7.58335 12.5417 7.58335V6.41669ZM1.45837 12.25H2.62621C2.62636 12.0966 2.59626 11.9447 2.53762 11.8029C2.47899 11.6612 2.39297 11.5324 2.2845 11.4239C2.17603 11.3154 2.04722 11.2294 1.90547 11.1708C1.76371 11.1121 1.61178 11.082 1.45837 11.0822V12.25ZM12.5417 12.25H11.375C11.375 11.9406 11.498 11.6439 11.7167 11.4251C11.9355 11.2063 12.2323 11.0834 12.5417 11.0834V12.25Z" stroke="#969696" stroke-width="1.16667" stroke-linecap="square"/>
            </g>
            <defs>
              <clipPath id="clip0_567_1743">
                <rect width="14" height="14" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </span>
        <span class="text-9696 f-12">
        <span *ngIf="job.salary_min"><i class="fa-solid {{job.target_currency_fav_icon}}"></i> {{formatNumberToIndianFormat(job.salary_min)}}</span> <span *ngIf="job.salary_min && job.salary_max"> - </span> <span *ngIf="job.salary_max"><i class="fa-solid {{job.target_currency_fav_icon}}"></i> {{formatNumberToIndianFormat(job.salary_max)}}</span>
        </span>
      </span>
    </div>
  </div>
</div>

<div class="new-pagination " *ngIf="sliderJoblist.length >0">
  <!-- <div>
    Total Entries: {{totalEntries}}
  </div> -->
  <!-- [disabled]="currentPage === 1" -->
  <!-- <div>
    <button data-testid="auto-app-insights-joblist-button-3" class="ml-2" (click)="firstPage()" [disabled]="currentPage === 1">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g [style.opacity]="currentPage === 1 ? 0.5 :  1">
          <path d="M12.1934 11.5267C12.4534 11.2667 12.4534 10.8467 12.1934 10.5867L9.61338 7.99999L12.2 5.41332C12.46 5.15332 12.46 4.73332 12.2 4.47332C11.94 4.21332 11.52 4.21332 11.26 4.47332L8.20005 7.53332C7.94005 7.79332 7.94005 8.21332 8.20005 8.47332L11.26 11.5333C11.5134 11.7867 11.9334 11.7867 12.1934 11.5267Z" fill="#5E5E5E"/>
          <path d="M7.80003 11.5267C8.06003 11.2667 8.06003 10.8467 7.80003 10.5867L5.22003 7.99999L7.80669 5.41332C8.06669 5.15332 8.06669 4.73332 7.80669 4.47332C7.54669 4.21332 7.12669 4.21332 6.86669 4.47332L3.80669 7.53332C3.54669 7.79332 3.54669 8.21332 3.80669 8.47332L6.86669 11.5333C7.12003 11.7867 7.54003 11.7867 7.80003 11.5267Z" fill="#5E5E5E"/>
        </g>
      </svg>
    </button>
    <button data-testid="auto-app-insights-joblist-button-4" class="ml-2" (click)="prevPage()" [disabled]="currentPage === 1">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g [style.opacity]="currentPage === 1 ? 0.5 :  1">
        <path d="M9.80669 10.5867L7.22003 7.99999L9.80669 5.41332C10.0667 5.15332 10.0667 4.73332 9.80669 4.47332C9.54669 4.21332 9.12669 4.21332 8.86669 4.47332L5.80669 7.53332C5.54669 7.79332 5.54669 8.21332 5.80669 8.47332L8.86669 11.5333C9.12669 11.7933 9.54669 11.7933 9.80669 11.5333C10.06 11.2733 10.0667 10.8467 9.80669 10.5867Z" fill="#5E5E5E"/>
      </g>
    </svg>
  </button>
    <span class="ml-2">
      <span class="activepage">
        {{currentPage}}
      </span>
      <span class="mx-2">/</span>
      <span>
        {{totalPages}}
      </span>
    </span>
    <button data-testid="auto-app-insights-joblist-button-5" class="ml-2" (click)="nextPage()" [disabled]="currentPage === totalPages">
      <svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none">
        <g [style.opacity]="currentPage === totalPages ? 0.5 :  1">
        <path d="M0.195 6.30833L2.78167 3.72167L0.195 1.135C-0.065 0.875 -0.065 0.455 0.195 0.195C0.455 -0.065 0.875 -0.065 1.135 0.195L4.195 3.255C4.455 3.515 4.455 3.935 4.195 4.195L1.135 7.255C0.875 7.515 0.455 7.515 0.195 7.255C-0.0583333 6.995 -0.065 6.56833 0.195 6.30833Z" fill="#5E5E5E"/>
        </g>
      </svg>
    </button>
    <button data-testid="auto-app-insights-joblist-button-6" class="ml-2" (click)="lastPage()" [disabled]="currentPage === totalPages">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g [style.opacity]="currentPage === totalPages ? 0.5 :  1">
        <path d="M3.79998 4.47331C3.53998 4.73331 3.53998 5.15331 3.79998 5.41331L6.38665 7.99997L3.79998 10.5866C3.53998 10.8466 3.53998 11.2666 3.79998 11.5266C4.05998 11.7866 4.47998 11.7866 4.73998 11.5266L7.79998 8.46664C8.05998 8.20664 8.05998 7.78664 7.79998 7.52664L4.74665 4.47331C4.48665 4.21331 4.05998 4.21331 3.79998 4.47331Z" fill="#5E5E5E"/>
        <path d="M8.19333 4.47331C7.93333 4.73331 7.93333 5.15331 8.19333 5.41331L10.78 7.99997L8.19333 10.5866C7.93333 10.8466 7.93333 11.2666 8.19333 11.5266C8.45333 11.7866 8.87333 11.7866 9.13333 11.5266L12.1933 8.46664C12.4533 8.20664 12.4533 7.78664 12.1933 7.52664L9.13333 4.46664C8.88 4.21331 8.45333 4.21331 8.19333 4.47331Z" fill="#5E5E5E"/>
        </g>
      </svg>
    </button>
  </div> -->
  <!-- [disabled]="currentPage >= totalPages" -->
  <!-- <ngb-pagination [collectionSize]="totalPages" [(page)]="currentPage" [maxSize]="5" [pageSize]="10"  (pageChange)="setPage($event)" ></ngb-pagination> -->

  <ngb-pagination class="w-100 d-flex justify-content-center" [collectionSize]=" totalEntries <= 100 ? totalEntries: 100" [maxSize]="5" [pageSize]="10" [rotate]="true"
    (pageChange)="setPage($event)" [(page)]="currentPage">
    <ng-template ngbPaginationPrevious> <span>Prev
    </span>
    </ng-template>
    <ng-template ngbPaginationNext>
      <span *ngIf="sliderJoblist?.length">Next</span> </ng-template>
  </ngb-pagination>
</div>
</div>
<!-- test -->
 <!-- <div>
  <h3>Items List</h3>

  <ul>
    <li *ngFor="let item of paginatedItems">
      Item {{ item.jobtitle }}
    </li>
  </ul>

  <div style="margin-top: 20px;"> -->

    <!-- First -->
    <!-- <button data-testid="auto-app-insights-joblist-button-7" (click)="firstPage()" [disabled]="currentPage === 1">
      <<
    </button> -->

    <!-- Previous -->
    <!-- <button data-testid="auto-app-insights-joblist-button-8" (click)="prevPage()" [disabled]="currentPage === 1">
      Prev
    </button>

    <span> Page {{ currentPage }} of {{ totalPages }} </span> -->

    <!-- Next -->
    <!-- <button data-testid="auto-app-insights-joblist-button-9" (click)="nextPage()" [disabled]="currentPage === totalPages">
      Next
    </button> -->

    <!-- Last -->
    <!-- <button data-testid="auto-app-insights-joblist-button-10" (click)="lastPage()" [disabled]="currentPage === totalPages">
      >>
    </button> -->

  <!-- </div>
</div> -->
